import { commanServicer } from "./common.services";

async function saveOrUpdateProfileMaster(payload: {
    profileId: number;
    name: string;
    mobileNo: string;
    isActive: boolean;
}) {
    return await commanServicer.fetchRequest(
        JSON.stringify(payload),
        true,
        'ProfileMaster/saveupdateprofilemaster',
        'POST'
    );
}

async function getProfileDetail(id: number) {
    return await commanServicer.fetchRequest(
        '',
        true,
        `ProfileMaster/getprofiledetail?id=${id}`,
        'GET'
    );
}

async function sendOtp() {
    return commanServicer.fetchRequest(
        JSON.stringify({}),
        true,
        "profilemaster/sendotp",
        "POST"
    );
}

async function verifyOtp(otp: number) {
    return commanServicer.fetchRequest(
        JSON.stringify({ otp }),
        true,
        "profilemaster/verifyotp",
        "POST"
    );
}

export const ProfileMasterService = {
    saveOrUpdateProfileMaster,
    getProfileDetail,
    sendOtp,
    verifyOtp,
};
